// import md5 from 'js-md5';
import {
    getUrlParams,
    fetchData,
    isBaiduApp,
    isBaiduMap,
    openMapIsBD,
    isAndroid,
    isWeiXin,
    openMap,
    isIPhone,
    setClipBoard,
    UlinkCallNa,
    assembleSrc,
    yingyongbaoCallUp,
    downPageCallUp,
    baiduMapJumpOtherApp
} from '../../utils';

import {appendParam, requestBdApi} from '@baidu/map-fe-utils';

// 截流函数
const throttle = (fn, delay, immediate) => {
    const wait = delay || 1000;
    let timer = null;
    return function (args) {
        const context = this;
        if (immediate) {
            if (!timer) {
                timer = setTimeout(() => {
                    timer = null;
                }, wait);
                fn.call(context, args);
            }
        }
        else {
            if (!timer) {
                timer = setTimeout(() => {
                    fn.call(context, args);
                    timer = null;
                }, wait);
            }
        }
    };
};

const getBosResizeUrl = ({src = '', width = 300, height = 300, quality = 80, focus = false}) => {
    try {
        if (!width && !height) {
            return src;
        }
        if (!src.startsWith('http://') && !src.startsWith('https://')) {
            return src;
        }

        // x-bce-process含义: bos定的图片处理协议，服务端处理图片已经加了x-bce-process尾缀不需要fe重复处理
        if (src.indexOf('x-bce-process') !== -1 && !focus) {
            return src;
        }

        const {protocol, hostname, pathname} = getLocation(src);
        // 非bos图片短期走厂内图片裁剪服务gimg
        if (!hostname.endsWith('.cdn.bcebos.com')) {
            return src;
        }

        let fixedPathname = pathname;
        // 如果使用了v1版本的处理方式https://cloud.baidu.com/doc/BOS/s/2ldh5woh2，则需要修正pathname
        if (pathname.includes('@')) {
            fixedPathname = pathname.split('@')[0];
        }
        if (
            fixedPathname.endsWith('.gif')
            || fixedPathname.endsWith('.GIF')
            || fixedPathname.endsWith('.9.png')
        ) {
            return src;
        }

        let resultUrl = `${protocol}//${hostname}${fixedPathname}`;
        resultUrl
            += '?x-bce-process=image'
            + '/resize,m_lfit'
            + (width ? ',w_' + width : '')
            + (height ? ',h_' + height : '')
            + ',limit_1'
            + (quality && quality <= 100 && quality > 0 ? '/quality,q_' + quality : '');
        return resultUrl;
    }
    catch (e) {
        return src;
    }
};

/**
 * 从 URL 中获取协议、主机名和端口号等信息，并返回一个对象。
 * @param {string} href 要解析的 URL 字符串
 * @returns {(object | undefined)} 返回包含解析结果的对象或undefined（如果传入的参数不是有效的链接）
 */
function getLocation(href) {
    if (!href) {
        return {};
    }
    let match = href.match(
        /^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/
    );
    return (
        match && {
            href: href,
            protocol: match[1],
            host: match[2],
            hostname: match[3],
            port: match[4],
            pathname: match[5],
            search: match[6],
            hash: match[7]
        }
    );
};

/**
 * 图片压缩工具包装方法
 * 具体参数含义见文档：http://wiki.baidu.com/pages/viewpage.action?pageId=1243071889
*/
// function compressWithGimg({
//     url,
//     q = 100,
//     size,
//     width = 9999,
//     height = 10000,
//     fmt = 'auto'
// }) {
//     try {
//         const rawUrl = getGimgRawSrc(url);
//         const time = 0;
//         const app = 2006;
//         const sizeStr = size || `f${width},${height}`;
//         const md5Str = `src=${rawUrl}&app=${app}&size=${sizeStr}&q=${q}&sec=${time}`;
//         const di = md5(md5Str);
//         const encodeUrl = encodeURIComponent(url);
//         const urlScheme = `https://gimg0.baidu.com/gimg/src=${encodeUrl}&app=2006&size=${sizeStr}&n=0&g=0n&q=${q}&fmt=${fmt}?sec=${time}&t=${di}`;
//         return urlScheme;
//     }
//     catch (e) {
//         console.error(e);
//     }
//     return url;
// };

// 获取 gimg 原始图的链接
function getGimgRawSrc(url) {
    try {
        if (!url || !url.startsWith('https://gimg0.baidu.com')) {
            return url;
        }
        const reg = 'src=(.*?)($|&)';
        const rst = url.match(reg);
        if (rst && rst[1]) {
            return getGimgRawSrc(decodeURIComponent(rst[1]));
        }
    }
    catch (e) {
        console.error(e);
    }
    return url;
};

/**
 * 上报接口
 * @param {Object} item 上报对象
 * @param {number} index 索引
 * @param {String} action 上报action行为 show/click
 */
function reportActionToRedies(item, index, action = 'show', phoneInfo) {
    const params = getUrlParams(location.href);
    const {origin_from = ''} = params || {};
    const uniqueid = item.unique_id;
    let param = {
        cuid: phoneInfo.cuid,
        uniqueid,
        rank: index,
        source: 'post_detail_feed',
        origin_from,
        action,
        ctm: `${new Date().getTime()}`
    };
    let dataJson = JSON.stringify([param]);
    let url
        = '/feed-server/useraction/report?src=feed_action_report'
        + `&type=detail_channel_${action}&data_format=1&key=${uniqueid}`;
    fetchData(url, {
        method: 'get',
        params: {data: dataJson}
    });
};
// 图片裁切高度处理
function imageHeightHandle(width, height, isSquare = false) {
    const winWidth = window.innerWidth;
    let swiperHeight = 0;
    if (isSquare) {
        swiperHeight = winWidth;
    }
    else if ((width / height) <= 3 / 4) {
        swiperHeight = 6 * winWidth / 5;
    }
    else if ((width / height) >= 4 / 3) {
        swiperHeight = 3 * winWidth / 4;
    }
    else {
        // 3/4和4/3中间，盒子是自适应
        swiperHeight = winWidth * height / width;
    }
    return swiperHeight;
}

const {protocol, hostname, port, pathname} = location;
const query = location.search;
// 拼接跳转端内，新媒体详情页地址参数
const targetAppUrl = `${protocol}//${hostname}:${port}${pathname}${query}`;

const src = assembleSrc('webapp.poi.poi_biji.h5');
const from = 'newMedia';
const token = 'WEBAPP9019';
const openapi = `baidumap://map/cost_share?hideshare=yes&navigationStatus=2&popRoot=no&attachinfo=1&hiddenTitle=1&hiddenBackBtn=1&url=${encodeURIComponent(
    targetAppUrl
)}&needLocation=yes&src=${src}`;

// 跳转到地图
function jumpToMapFun(callback, jumpToAppUrl) {
    // 如果是百度APP，直接唤起
    if (isBaiduApp()) {
        let params = {
            url: targetAppUrl,
            src,
            payload: {
                from,
                token
            },
            openapi
        };
        openMapIsBD(params);
    }

    // 拼接跳转链接，安卓微信走微信开发标签
    else if (isAndroid() && isWeiXin()) {
        openMap({
            url: targetAppUrl,
            src,
            from,
            token,
            openapi
        });
    }
    else {
        // 其余情况下点击去百度地图查看即调起，2.5s后弹框
        initCallInstant(callback, jumpToAppUrl);
    }
}
// IOS端ulink即调起，安卓端，即调起，统一2.5s后出拉新去体验弹框
function initCallInstant(callback, jumpToAppUrl) {
    // IOS端ulink即调起
    if (isIPhone()) {
        setClipBoard(token);
        let wxToAppUrl = openapi;
        if (isWeiXin()) {
            wxToAppUrl = jumpToAppUrl;
        }
        let params = {
            src,
            from,
            token,
            openapi: wxToAppUrl
        };
        // ulink即调起
        UlinkCallNa(params);
    }
    else if (!isBaiduApp() && !isBaiduMap() && !isWeiXin()) {
        // 安卓端，即调起，统一2.5s后出拉新去体验弹框
        window.location.href = openapi;
        setTimeout(() => {
            callback && callback();
        }, 2500);
    }
}
// ios直接用ulink即调起，不出弹框，只有安卓会出弹框
function clickMaskOrBtn(obj, callback) {
    if (obj.method === 'jump') {
        setClipBoard(token);
        // 如果是QQ浏览器，保持和webapp里面一致的逻辑
        if (/QQBrowser/i.test(navigator.userAgent)) {
            // 和webapp一样的逻辑，进入应用宝下载页面，如果进入白色下载页会提示网站含有有害信息
            yingyongbaoCallUp(from, token, openapi);
        }
        else {
            // 其他浏览器，统一进入白色下载页，UC和小米默认浏览器不会提示网站信息
            downPageCallUp(from, token, openapi);
        }
    }
    callback && callback();
}

// push返回拉起首页feed，与端通信
function setbackData(val) {
    let data = {};
    data.module_name = 'du_aide_feed';
    let extparam = {};
    extparam.source = 'push_feed';
    extparam.origin_from = 'push_feed';
    if (val === 'oppooem') {
        extparam.source = val;
        extparam.origin_from = val;
    }
    if (val === true) {
        extparam.push_toast_flag = val;
        extparam.origin_from = '';
    }
    data.extparam = JSON.stringify(extparam);
    requestBdApi('bdapi://setbackData?data=' + encodeURIComponent(JSON.stringify(data)));
}
// 是否展示轮播图
function setShowSwiper(item, source) {
    const {body: {album = {}} = {}, actionBar: {author: {tpSource = '', subSource = ''} = {}} = {}} = item;
    // 针对来源为pushnote且tp不等于push的微详情笔记，首图轮播图不展示。
    if (source === 'pushnote' && subSource === 'baijiahao_hot_news') {
        return false;
    }
    const {content = []} = album;
    // 检查是否至少有一个content项的src不是空的
    const hasNonEmptySrc = content.some(item => item.src && item.src.trim());

    return tpSource !== 'push' && hasNonEmptySrc;
}
// 跳转到第三方app
function goThirdApp({jumpParam, directJump, detailUrl, feedType}) {
    if (!detailUrl) {
        return;
    }

    if (detailUrl.indexOf('baidumap://') >= 0) {
        window.location.href = detailUrl;
        return;
    }

    // directJump为true，直接跳转
    if (directJump) {
        baiduMapJumpOtherApp(jumpParam);
        return;
    }

    if (feedType !== 'comment') {
        window.location.href = 'baidumap://map/mnp?popRoot=no&url=' + encodeURIComponent(detailUrl);
    }
}

// 微信内打开app的url
function getJumpWxAppUrl({appType = 'webapp.poi.poi_biji.weixin', unique_id = '', wxShareUid = '', dataType = ''}) {
    const {origin, pathname} = location;
    const url = `${origin}${pathname}`;
    // 微信内戳点后笔记变化，微信内跳转到app取戳点后的笔记第一篇unique_id和uid
    const appParam = {
        unique_id,
        uid: wxShareUid,
        reqType: dataType || '',
        topic: 'default',
        tplType: 'article',
        source: 'sharefeed'
    };
    const appendUrl = appendParam(url, appParam);
    const webAppSrc = assembleSrc(appType);
    const wxAppUrl = `baidumap://map/cost_share?hideshare=yes&navigationStatus=2&popRoot=no&attachinfo=1&hiddenTitle=1&hiddenBackBtn=1&mode=MAP_MODE&url=${encodeURIComponent(
        appendUrl
        // todo needLocation=yes时调起app时，未授权定位时，不会直接打开微详情页面，app内会提示授权定位，授权定位后才可直接打开微详情页面，考虑移除needLocation=yes
    )}&needLocation=yes&src=${webAppSrc}`;

    return wxAppUrl;
}
export {
    throttle,
    getBosResizeUrl,
    reportActionToRedies,
    imageHeightHandle,
    jumpToMapFun,
    clickMaskOrBtn,
    getLocation,
    setbackData,
    getJumpWxAppUrl,
    setShowSwiper,
    goThirdApp
};